module.exports = {"542227100":"措美镇","542227101":"哲古镇","542227200":"乃西乡","542227201":"古堆乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542227.json
// module id = 2545
// module chunks = 0